import 'react-toastify/dist/ReactToastify.css';

import styled from '@emotion/styled';
import React from 'react';
import { ToastContainer } from 'react-toastify';
import { AUTO_CLOSE_DURATION_IN_MS, TOASTS_LIMIT } from './vy-toast-consts';
import { VyToastCloseButton } from './vy-toast-container-components';

const VyToastContainer: React.FC = () => (
  <ToastContainer
    hideProgressBar
    pauseOnHover
    closeButton={VyToastCloseButton}
    position='bottom-left'
    autoClose={AUTO_CLOSE_DURATION_IN_MS}
    limit={TOASTS_LIMIT}
  />
);

const StyledVyToastContainer = styled(VyToastContainer)`
.Toastify__toast-container {
    width: 320px; 
    height: 46px;
    top: 962px; 
    left: 16px; 
  }

  .Toastify__toast-body > div:last-child {
    color: #0D1B27DE;
  }

  .Toastify__close-button svg {
    height: 32px;
    width: 32px;
    color: 'black';
  }

  .Toastify__close-button {
    align-self: normal;
    color: black;
  }
`;

export { StyledVyToastContainer as VyToastContainer };